import { withUpdateContributorWeights } from 'modules/Objective-keyresult/container/objective-keyresult-operations';
import React from 'react';
import { compose } from '../../../core';
import { withApollo } from '@apollo/client/react/hoc';
import AddWeightButton from '../AddWeightButton';
const AddWeightContainer = props => {

    const {visible,allokrweights} = props
    const [loading, setloading] = React.useState(true)
    return (
        <>
            <AddWeightButton {...props} visible={visible} allokrweights={allokrweights} loading={loading} setloading={(e) => setloading(e)}/>
        </>
    );
};

export default compose(withApollo, withUpdateContributorWeights)(AddWeightContainer);
